import { render, staticRenderFns } from "./setting-vacation.vue?vue&type=template&id=84dad636&"
import script from "./setting-vacation.vue?vue&type=script&lang=js&"
export * from "./setting-vacation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports